import { Button } from '@/components/ui/button';
import { Calendar, Clock, CalendarDays } from 'lucide-react';

interface DatePresetsProps {
  onPresetSelect: (startDate: Date, endDate: Date) => void;
  disabled?: boolean;
}

const presets = [
  {
    label: 'Hoje',
    icon: Clock,
    getValue: () => {
      const today = new Date();
      return { start: today, end: today };
    }
  },
  {
    label: 'Últimos 7 dias',
    icon: Calendar,
    getValue: () => {
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 7);
      return { start, end };
    }
  },
  {
    label: 'Últimos 30 dias',
    icon: CalendarDays,
    getValue: () => {
      const end = new Date();
      const start = new Date();
      start.setDate(start.getDate() - 30);
      return { start, end };
    }
  },
  {
    label: 'Este mês',
    icon: CalendarDays,
    getValue: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return { start, end };
    }
  }
];

export default function DatePresets({ onPresetSelect, disabled = false }: DatePresetsProps) {
  const handlePresetClick = (preset: typeof presets[0]) => {
    const { start, end } = preset.getValue();
    onPresetSelect(start, end);
  };

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <span className="text-sm font-medium text-gray-600 flex items-center mr-2">
        Períodos rápidos:
      </span>
      {presets.map((preset) => {
        const Icon = preset.icon;
        return (
          <Button
            key={preset.label}
            variant="outline"
            size="sm"
            onClick={() => handlePresetClick(preset)}
            disabled={disabled}
            className="text-xs"
          >
            <Icon className="h-3 w-3 mr-1" />
            {preset.label}
          </Button>
        );
      })}
    </div>
  );
}